import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { uniqBy } from "lodash";
import i18next from "../../common/i18n";
import { db, enums, http } from "../../common/lib";
import { actionCreators, actionTypes } from "./actions";
import { actionCreators as toastActions } from "../toast/actions";
import { get, update } from "idb-keyval";
import config from "../../config";
import { logToSentry } from "../../config/Sentry";

function* post(action) {
    const { detail } = action.payload;
    try {
        yield call(http.authorized.post, config.api.paths.userLanguage, detail);
        yield put(actionCreators.postSuccess());
    } catch (error) {
        const errStr = error.toString();
        logToSentry("language change post", {
            error,
            detail,
        });
        yield all([
            put(actionCreators.postFailure(errStr)),
            put(toastActions.error(i18next.t("errors.languageChangePost"))),
        ]);
    }
}

export { post };

export default (function* () {
    yield all([takeLatest(actionTypes.USER_LANGUAGE_POST_REQUEST, post)]);
})();
